import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { getTablePartController, getTPCommandPanel } from '../../../../BaseEditor';
import { GridTemplate } from './styles';
import BodyComponent from './body';
import HeaderComponent from './header';
import { StyledButton, StyledImg, StyledText } from '../../../../../components/Styled/Buttons/styledCommandPanelButton';
import { DraftIcon } from '../../../../../components/Styled/Buttons/icons';
import api from '../../../../../api/req';
// import md from '../../../../../const/meta';
import { AppContext } from '../../../../../providers/authProvider';

function FillContract({ onChange, data, date }) {
  const { auth } = useContext(AppContext);
  const loadContracts = useCallback(
    async () => {
      const r = await api.get('/api/calculationofpayments/fill', auth, { date });
      if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
      return r.json();
    },
    [auth, date],
  );
  const onFillContract = useCallback(
    (e) => {
      loadContracts()
        .then((d) => {
          onChange(e, [...data, ...d]);
        });
    },
    [data, loadContracts, onChange],
  );
  return (
    <StyledButton
      title="Заповнити договорами, за якими внесені залишки, але за якими нема розрахунку"
      onClick={onFillContract}
    >
      <StyledImg src={DraftIcon} alt="Заповнити договорами" />
      <StyledText>Заповнити договорами</StyledText>
    </StyledButton>
  );
}

FillContract.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape([
  ])).isRequired,
  date: PropTypes.string.isRequired,
};

const CommandPanel = getTPCommandPanel(FillContract);

const newRecordData = () => ({
  contract: { id: null, repr: '' },
  amount: null,
});

export default getTablePartController(
  GridTemplate,
  BodyComponent,
  newRecordData,
  CommandPanel,
  HeaderComponent,
);
